export const blockIconsTransportationTrainNew = (
	<span className='material-symbols-outlined'>train</span>
);
